import type { KlardatenInstance } from '../../api/klardaten-credentials';
import type { McpOAuthHints, McpServerConfig } from '../../api/mcp-servers';
import { getKlardatenInstanceLabel } from '../../utils/klardaten-display';

const KLARDATEN_MCP_PREFIX = 'Klardaten MCP';

function nonEmpty(value: string | null | undefined): string | null {
  return typeof value === 'string' && value.trim() ? value.trim() : null;
}

function uniqueName(base: string, existingNames: Set<string>): string {
  if (!existingNames.has(base)) return base;

  let suffix = 2;
  while (existingNames.has(`${base} #${suffix}`)) {
    suffix += 1;
  }
  return `${base} #${suffix}`;
}

export function buildKlardatenMcpHints(
  instanceId: string | null | undefined,
  profileId: string | null | undefined
): McpOAuthHints {
  const selectedInstanceId = nonEmpty(instanceId);
  return {
    instanceId: selectedInstanceId,
    profileId: selectedInstanceId ? nonEmpty(profileId) : null,
  };
}

export function getKlardatenMcpServerName(
  servers: McpServerConfig[],
  instance?: KlardatenInstance | null
): string {
  const existingNames = new Set(servers.map((server) => server.name));

  if (instance) {
    return uniqueName(
      `${KLARDATEN_MCP_PREFIX} - ${getKlardatenInstanceLabel(instance)}`,
      existingNames
    );
  }

  const existingNumbers = servers
    .map((server) => {
      const match = server.name.match(/^Klardaten MCP(?: #(\d+))?$/);
      if (!match) return 0;
      return match[1] ? parseInt(match[1], 10) : 1;
    })
    .filter((value) => value > 0);

  const nextNumber =
    existingNumbers.length > 0 ? Math.max(...existingNumbers) + 1 : 1;
  return `${KLARDATEN_MCP_PREFIX} #${nextNumber}`;
}
